export const EXPENSE_ROUTE_NAMES = {
    LIST: "ExpenseList",
    ADD: "ExpenseAdd",
    EDIT: "ExpenseEdit",
};
